









































import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useUiHelpers } from '~/composables';

export default defineComponent({
	name: 'CategoryChild',
	props: {
		parent: Object,
		category: Object,
		type: {
			type: String,
			default: 'square',
		}
	},
	head() {
		const title = 'Products - Vizulo';
		const meta = [];

		return {
			title,
			meta,
		};
	},
    setup(props) {
        const { getCatLink } = useUiHelpers();
        const categoryImage = computed(() => props.category?.image ?? '');

        return {
            getCatLink,
            categoryImage,
        };
    }
})
